import { Component, OnInit, OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Subscription } from "rxjs";
import {
  LoginPromptService,
  LoginPromptState,
} from "../../../services/login-prompt.service";

@Component({
  selector: "app-login-prompt",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="login-prompt-overlay"
      *ngIf="state.isVisible"
      (click)="onOverlayClick()"
    >
      <div class="login-prompt-modal" (click)="$event.stopPropagation()">
        <div class="prompt-header">
          <div class="prompt-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
              <polyline points="10 17 15 12 10 7" />
              <line x1="15" y1="12" x2="3" y2="12" />
            </svg>
          </div>
          <h3 class="prompt-title">Login Required</h3>
        </div>

        <div class="prompt-content">
          <p class="prompt-message">{{ state.message }}</p>
        </div>

        <div class="prompt-actions">
          <button class="prompt-btn primary" (click)="goToLogin()">
            <span class="btn-text">Log In</span>
          </button>
          <button class="prompt-btn secondary" (click)="goToRegister()">
            <span class="btn-text">Create Account</span>
          </button>
          <button class="prompt-btn ghost" (click)="continueBrowsing()">
            <span class="btn-text">Continue Browsing</span>
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .login-prompt-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10001;
        backdrop-filter: blur(4px);
        padding: 16px;
      }

      .login-prompt-modal {
        background: white;
        border-radius: 24px;
        max-width: 360px;
        width: 100%;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        animation: promptSlideIn 0.3s ease-out;
      }

      @keyframes promptSlideIn {
        from {
          opacity: 0;
          transform: translateY(-20px) scale(0.95);
        }
        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }

      .prompt-header {
        background: var(--rb-primary);
        color: white;
        padding: 32px 24px;
        text-align: center;
      }

      .prompt-icon {
        margin-bottom: 16px;
      }

      .prompt-icon svg {
        width: 48px;
        height: 48px;
      }

      .prompt-title {
        font-size: 20px;
        font-weight: 700;
        margin: 0;
      }

      .prompt-content {
        padding: 24px;
        text-align: center;
      }

      .prompt-message {
        font-size: 16px;
        color: #374151;
        line-height: 1.5;
        margin: 0;
      }

      .prompt-actions {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 0 24px 24px;
      }

      .prompt-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 14px 24px;
        border: none;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: 16px;
        font-weight: 600;
        width: 100%;
      }

      .prompt-btn.primary {
        background: var(--rb-primary);
        color: white;
      }

      .prompt-btn.primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(30, 64, 175, 0.4);
      }

      .prompt-btn.secondary {
        background: #f1f5f9;
        color: var(--rb-teal);
      }

      .prompt-btn.secondary:hover {
        background: #e2e8f0;
      }

      .prompt-btn.ghost {
        background: transparent;
        color: #64748b;
      }

      .prompt-btn.ghost:hover {
        color: #374151;
        background: #f8fafc;
      }
    `,
  ],
})
export class LoginPromptComponent implements OnInit, OnDestroy {
  state: LoginPromptState = { isVisible: false, message: "", returnUrl: null };
  private subscription?: Subscription;

  constructor(private loginPromptService: LoginPromptService) {}

  ngOnInit() {
    this.subscription = this.loginPromptService.state$.subscribe(
      (s) => (this.state = s),
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onOverlayClick() {
    this.continueBrowsing();
  }

  goToLogin() {
    this.loginPromptService.goToLogin();
  }

  goToRegister() {
    this.loginPromptService.goToRegister();
  }

  continueBrowsing() {
    this.loginPromptService.continueBrowsing();
  }
}
